module.exports = __webpack_public_path__ + "static/media/podcast-generic.38366adc.png";